import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    AllianceEnum,
    AllianceObject,
    AllianceUrlEnum,
    getAlliance,
    getCatalogBaseUrl,
} from "enums/alliance.enum";

const VALID_ALLIANCES = Object.keys(AllianceObject);

function useAlliance(
    redirectUrl?: string,
    validAlliances: string[] = VALID_ALLIANCES,
) {
    const { alianza } = useParams();
    const navigate = useNavigate();

    const [alliance, setAlliance] = useState<AllianceEnum>();
    const [allianceUrl, setAllianceUrl] = useState<AllianceUrlEnum>();
    const [isValid, setIsValid] = useState<boolean>();
    const [catalogBaseUrl, setCatalogBaseUrl] = useState<string>("/catalogo");
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (alianza) {
            const isValidValue = validAlliances.includes(alianza.toLowerCase() as AllianceUrlEnum);
            setIsValid(isValidValue);
            if (isValidValue) {
                setAlliance(getAlliance(alianza as AllianceUrlEnum));
                setAllianceUrl(alianza as AllianceUrlEnum);
            } else if (redirectUrl) {
                navigate(redirectUrl);
            }
        }
        setLoading(false);
    }, [alianza]);

    useEffect(() => {
        if (alianza && alliance) {
            setCatalogBaseUrl(getCatalogBaseUrl(alliance));
        }
    }, [alliance]);

    return {
        alliance,
        allianceUrl,
        isValid,
        catalogBaseUrl,
        loading,
    };
}

export default useAlliance;
